import type { UseQueryOptions } from "react-query";
import { useQuery } from "react-query";
import { segmentsApi } from "@circle-react/api/segmentsApi";
import type { ApiError } from "@circle-react/config/CustomErrors";
import type { SegmentPage } from "./useSegmentsInfiniteQuery";
import { SEGMENTS_QUERY_KEY_PREFIX } from "./useSegmentsInfiniteQuery";

export const SHOW_SEGMENT_QUERY_KEY_PREFIX = "show";

export const useGetSegment = ({
  id,
  options = {},
}: {
  id: number;
  options?: UseQueryOptions<SegmentPage, ApiError>;
}) =>
  useQuery<SegmentPage, ApiError>({
    queryKey: [SEGMENTS_QUERY_KEY_PREFIX, SHOW_SEGMENT_QUERY_KEY_PREFIX, id],
    queryFn: () => segmentsApi.show({ id }),
    enabled: !!id,
    ...options,
  });
